import React, { createContext, useContext, useLayoutEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {} });
const THEME_KEY = "muhasabaty_theme";
const EXPLICIT_CHOICE_KEY = "muhasabaty_theme_explicit_choice_v1";

function getInitialTheme() {
  if (typeof window === "undefined") return "light";
  try {
    const explicitChoice = window.localStorage.getItem(EXPLICIT_CHOICE_KEY);
    if (explicitChoice === "dark" || explicitChoice === "light") return explicitChoice;
  } catch {
    // Private browsing/storage restrictions fall back to the accessible light theme.
  }
  // Do not use the operating system's dark preference or the legacy key here:
  // earlier versions saved that automatic preference as if the user had chosen it.
  return "light";
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.style.colorScheme = theme;
    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch {
      // The theme still applies for this session if storage is unavailable.
    }
  }, [theme]);

  const toggle = () => {
    const nextTheme = theme === "dark" ? "light" : "dark";
    try {
      window.localStorage.setItem(EXPLICIT_CHOICE_KEY, nextTheme);
    } catch {
      // Keep the selection in React state even if storage is unavailable.
    }
    setTheme(nextTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
